import { AllocationBase } from "../../accounting/abstract/allocation-base.model";

export class BankAccountRuleAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'BankAccountRuleAllocation';

}
